<template>
  <div>
    <template v-for="(field, id) in fields">
      <RangeInput
        v-if="field.type === 'range-input'"
        :key="`${id}_range-input`"
        :fields="field"
        class="mb-2"
      />
      <ValueHelpWrapper
        v-else-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput v-else :key="id" v-bind="field" class="mb-2" />
    </template>
  </div>
</template>

<script>
import { tabelFilterFields } from './lib/tabelFilterFields'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import RangeInput from './wrapper/RangeInput.vue'

export default {
  components: {
    RangeInput,
    ValueHelpWrapper,
  },
  data() {
    return {}
  },
  props: {
    formValues: {},
    fullObjects: {},
  },
  computed: {
    fields() {
      return tabelFilterFields(this).filter((field) => field.isShow !== false)
    },
  },
}
</script>
